import { Button, Input } from "antd";
import { useEffect, useState } from "react";
import { createAppSecret, deleteAppSecret, getAppSecrets } from "./service";
import { showToast } from "ui/components/common";
import { DeleteOutlined } from "@ant-design/icons";
export function OpenApi() {
  const [appName, setAppName] = useState("");
  const [details, setDetails] = useState(null);
  useEffect(() => {
    refreshDetails();
  }, []);
  const refreshDetails = async () => {
    const res = await getAppSecrets();
    if (res.status === 200) {
      setDetails(res?.data?.openapi);
    } else {
      showToast(1, "Failed to get app secrets");
    }
  };
  const onGenerateClick = async () => {
    const res = await createAppSecret(appName);
    if (res.status === 200) {
      refreshDetails();
    } else {
      showToast(1, "Failed to generate app secret");
    }
  };
  const doDelete = async () => {
    const res = await deleteAppSecret(details.clientId);
    if (res.status === 200) {
      setDetails(null);
      showToast(0, "App secret deleted successfully");
    } else {
      showToast(1, "Failed to delete app secret");
    }
  };
  return (
    <div
      style={{
        borderRadius: "16px",
        padding: "12px",
        width: "700px",
        margin: "auto",
      }}
      className="bg-neutral-100 p-5"
    >
      <div
        style={{
          fontWeight: "400",
          fontSize: "14px",
          marginBottom: "8px",
        }}
      >
        App Name
      </div>
      <Input
        style={{
          height: "54px",
          borderRadius: "16px",
          display: "block",
        }}
        value={appName}
        onChange={(e) => setAppName(e.target.value)}
      />
      <div style={{ width: "100%", textAlign: "right" }}>
        <Button
          className="primaryButton"
          style={{ marginTop: "12px" }}
          onClick={onGenerateClick}
          disabled={details}
        >
          Generate Authentication
        </Button>
      </div>

      {details && (
        <>
          <div
            style={{
              border: "1px solid rgba(225, 225, 225, 1)",
              marginTop: "12px",
            }}
          />
          <div style={{ padding: "12px", width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span style={{ fontSize: "16px", fontWeight: "600" }}>
                Authentication Details
              </span>
              <DeleteOutlined onClick={doDelete} />
            </div>
            <table>
              <tr style={{ height: "35px" }}>
                <td
                  style={{
                    color: "rgba(113, 113, 113, 1)",
                    whiteSpace: "nowrap",
                  }}
                >
                  App Name
                </td>
                <td
                  style={{
                    paddingLeft: "12px",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  {details.clientName}
                </td>
              </tr>
              <tr style={{ height: "35px" }}>
                <td
                  style={{
                    color: "rgba(113, 113, 113, 1)",
                    whiteSpace: "nowrap",
                  }}
                >
                  Client ID
                </td>
                <td
                  style={{
                    paddingLeft: "12px",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  {details.clientId}
                </td>
              </tr>
              <tr style={{ height: "35px" }}>
                <td
                  style={{
                    color: "rgba(113, 113, 113, 1)",
                    whiteSpace: "nowrap",
                  }}
                >
                  Client Secret
                </td>
                <td
                  style={{
                    paddingLeft: "12px",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  {details.clientSecret}
                </td>
              </tr>
              <tr style={{ height: "35px" }}>
                <td
                  style={{
                    color: "rgba(113, 113, 113, 1)",
                    whiteSpace: "nowrap",
                  }}
                >
                  Expiration Date
                </td>
                <td
                  style={{
                    paddingLeft: "12px",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                >
                  {details.secretExpiredAt}
                </td>
              </tr>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
